import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API
import { addQueryToUrl } from '@/utils/utils'

// 分页查询订单列表
export function getPurchaseOrderListApi(data) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/list`,
    method: 'post',
    data
  })
}

// 删除已保存的项目
export function deletePurchaseOrderApi(orderId) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/${orderId}/delete`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询详情
export function getPurchaseOrderDetailApi(orderId) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/${orderId}/detail`,
    method: 'get'
  })
}

// 导出订单详情的excel
export function exportPurchaseOrderApi(orderId) {
  window.open(
    addQueryToUrl(`${baseUrl}/workbench/oms/purchaser/${orderId}/export`),
    '_blank'
  )
}

// 保存
export function savePurchaseOrderApi(data) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/save`,
    method: 'post',
    data
  })
}

// 发布订单
export function publishPurchaseOrderApi(data) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/publish`,
    method: 'post',
    data
  })
}

// 编辑并发布订单
export function editPublishPurchaseOrderApi(data) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/edit-publish`,
    method: 'post',
    data
  })
}

// 查询可以关联订单 定点采购类型的采购方案
export function getPurchaseRelationOrderPlanListApi(params) {
  return request({
    url: `${baseUrl}/workbench/demander/purchase-plans/page/relation-order`,
    method: 'get',
    params
  })
}

// 确认收货
export function confirmOrderReceiptApi(orderId) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/${orderId}/confirmTakeGoods`,
    method: 'post'
  })
}

// 重推订单
export function setOrderPushApi(orderId) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/${orderId}/push`,
    method: 'post'
  })
}

// 删除订单
export function deleteOrderApi(orderId) {
  return request({
    url: `${baseUrl}/workbench/oms/purchaser/${orderId}/delete`,
    method: 'delete'
  })
}
